import { doc, onSnapshot } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { db, auth } from '../../backend/firebase'
import Header from '../../components/Header'
import Dataset from '../../components/Dataset'
import './PrivateCollection.css'

const PrivateCollection = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [collectionData, setCollectionData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    // Check if user is authenticated
    if (!auth.currentUser) {
      setError("You need to be logged in to view this collection")
      setLoading(false)
      return
    }

    const collectionRef = doc(db, "Users", auth.currentUser.uid, "collections", id)
    
    const unsubscribe = onSnapshot(
      collectionRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setCollectionData(snapshot.data())
          setError(null)
        } else {
          setError("Collection not found or you don't have access to it")
        }
        setLoading(false)
      },
      (err) => {
        console.error("Error fetching collection:", err)
        setError("Failed to load collection data")
        setLoading(false)
      }
    )

    return () => unsubscribe()
  }, [id])

  if (loading) {
    return (
      <div className="collection-screen private-collection">
        <div className="collection-loading">
          <div className="collection-spinner"></div>
          <p>Loading collection...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="collection-screen private-collection">
        <div className="collection-error">
          <p className="error-message">{error}</p>
          <button 
            onClick={() => navigate('/')}
            className="home-button"
          >
            Go to Home
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="collection-screen private-collection">

      {/* Collection Header */}
      <div className="collection-header">
        <div className="collection-info">
          <div className="collection-avatar">
            {collectionData.collectionName?.[0]?.toUpperCase() || '?'}
          </div>
          <div className="collection-details">
            <h1 className="collection-title">{collectionData.collectionName || 'Unnamed Collection'}</h1>
            <p className="collection-description">
              {collectionData.description || 'No description provided'}
            </p>
          </div>
        </div>
        <span className={`privacy-badge ${collectionData.isPrivate ? 'private' : 'public'}`}>
          {collectionData.isPrivate ? "Private" : "Public"}
        </span>
      </div>
      
      {/* Collection Content */}
      <div className="collection-content">
        {collectionData?.datasets?.length > 0 ? (
          <>
            <div className="datasets-header">
              <h3 className="datasets-title">Saved into Collection</h3>
            </div>
            <div className="datasets-grid">
              {collectionData.datasets.map((dataset, index) => (
                <Dataset key={index} datasetid={dataset} />
              ))}
            </div>
          </>
        ) : (
          <div className="empty-collection">
            <h3 className="empty-title">This collection is empty</h3>
            <p className="empty-description">
              Start adding datasets to build your collection
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default PrivateCollection